import { Grid } from '@mui/material';
import { FormikErrors } from 'formik';
import React, { useMemo } from 'react';

import ValueMappingCriteriaRow from '@Components/ValueMappingCriteriaRow';
import { useGlobalization } from '@Translations/useGlobalization';
import { ValuemappingProfileFormShape } from '@Types/valuemappingForm.types';
import ValueMappingMissingRow from './ValueMappingMissingRow';

interface ValueMappingMappingRowProps {
	index: number;
	methodOptions: string[];
	endAdornment?: React.ReactNode;
	disabled?: boolean;
	disabledFields?: {
		method?: boolean;
		to?: boolean;
	};
	errors: Partial<FormikErrors<ValuemappingProfileFormShape>>;
}

export const ValuemappingMappingRow = ({
	index,
	methodOptions,
	endAdornment,
	errors,
}: ValueMappingMappingRowProps) => {
	const { t } = useGlobalization();

	const mappingMethodOptionItems = useMemo(
		() =>
			methodOptions.map((opt: string) => {
				const optionValue = { key: opt, value: opt, label: opt };
				if (opt === 'Last Known Value') {
					optionValue.label = t('Last Known Value');
				}
				if (opt === 'Custom') optionValue.label = t('Custom');
				return optionValue;
			}),
		[methodOptions],
	);

	if (index === 0) {
		return (
			<>
				<ValueMappingMissingRow
					index={index}
					mappingMethodOptionItems={mappingMethodOptionItems}
					errors={errors}
				/>
				{endAdornment ?? undefined}
			</>
		);
	}

	return (
		<Grid
			data-cy="criteriaRow"
			item
			spacing={2}
			style={{ marginTop: '0', paddingTop: '0' }}
			direction="row-reverse">
			<Grid item container>
				<ValueMappingCriteriaRow
					index={index}
					methodOptions={methodOptions}
					errors={errors}
				/>
				{endAdornment ?? undefined}
			</Grid>
		</Grid>
	);
};

ValuemappingMappingRow.defaultProps = {
	disabled: false,
};

export default ValuemappingMappingRow;
